export enum FilterTypes {
  IdentificationNumber = 'IdentificationNumbers',
  YearOfIncorporation = 'YearIncorporation',
  Website = 'Website',
  CategoryOfCompany = 'CompanyBySize',
  Status = 'Status',
  Location = 'Location',
  LegalForm = 'LegalForm',
  AccountType = 'AccountType',
  NumberOfEmployees = 'NumberOfEmployees',
  IndustryClassifications = 'IndustryClassifications',
  BVDIndependenceIndicator = 'BVDIndependenceIndicator',
  ShareholderCharacteristics = 'ShareholderCharacteristics',
  SubsidiaryCharacteristics = 'SubsidiaryCharacteristics',
  Financial = 'Financial',
  CompanyName = 'CompanyName',
  Keywords = 'Keywords',
  ListedUnlisted = 'ListedUnlisted',
}

export enum NumberOfEmployeesRelativeYears {
  All,
  LastAvailable = 0,
  LastAvailable1 = -1,
  LastAvailable2 = -2,
  LastAvailable3 = -3,
  LastAvailable4 = -4,
  LastAvailable5 = -5,
  LastAvailable6 = -6,
  LastAvailable7 = -7,
  LastAvailable8 = -8,
  LastAvailable9 = -9,
}

export enum NumberOfEmployeesValidCriteria {
  AtLeastOne = 'at least one of the selected years',
  AllSelected = 'all selected years',
}

export enum BvdIndependenceOptions {
  APlus = 0,
  A = 1,
  AMinus = 2,
  BPlus = 3,
  B = 4,
  BMinus = 5,
  CPlus = 6,
  C = 7,
  D = 8,
  U = 9,
  All = 10,
  OneOrMore = 11,
  AddBranch = 12,
}

export enum FinancialCriteriaOptions {
  DataAvailability = 'DataAvailability',
  FinancialCriteria = 'FinancialCriteria',
  FinancialRatio = 'FinancialRatio',
  FinancialItem = 'FinancialItem',
}

export enum LookupFilterTypes {
  IdentificationNumbers = 23,
  YearIncorporation = 24,
  Website = 25,
  CompanyBySize = 26,
  Location = 27,
  Status = 28,
  AccountType = 29,
  ShareholderCharacteristics = 30,
  LegalForm = 31,
  NumberOfEmployees = 32,
  IndustryClassifications = 62,
  OwnershipData = 64,
  SubsidiaryCharacteristics = 101,
  BVDIndependenceIndicator = 115,
  Financial = 129,
  FinancialType = 53,
}
